import React from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Expertise from '../components/Expertise';
import Achievements from '../components/Achievements';
import Publications from '../components/Publications';
import InternationalSpeaking from '../components/InternationalSpeaking';
import CommunityConnect from '../components/CommunityConnect';
import AwardsTimeline from '../components/AwardsTimeline';
import MediaPress from '../components/MediaPress';
import PatientResources from '../components/PatientResources';
import Newsletter from '../components/Newsletter';
import Contact from '../components/Contact';
import Testimonials from '../components/Testimonials';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        path="/"
        description="Dr. Venkata Pradeep Babu Koyyala - Leading Medical Oncologist in Tezpur, Assam. EC Member ISMPO, Executive Secretary NESMO. Expert in chemotherapy, immunotherapy, targeted therapy, palliative care. Director & CEO, Shankara Cancer and Research Institute."
        keywords="Dr Venkata Pradeep Babu Koyyala, Medical Oncologist Tezpur, Cancer Doctor Assam, Oncologist Northeast India, ISMPO EC Member, NESMO, Cancer Treatment, Chemotherapy, Immunotherapy, Breast Cancer, Lung Cancer"
      />
      <Navigation />
      <Hero />
      <About />
      <Expertise />
      <Achievements />
      <AwardsTimeline />
      <InternationalSpeaking />
      <Publications />
      <MediaPress />
      <CommunityConnect />
      <PatientResources />
      <Newsletter />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
};

export default HomePage;
